import { defineMessage } from 'react-intl';

/** Primary label when create should stay on the logger stream. */
export const createOnlyMessage = defineMessage({
  id: 'fragments.addScreen.createOnly',
  defaultMessage: 'Crear',
});

/** Short primary label when create navigates to the fragment page (fits the footer button). */
export const createAndGoShortMessage = defineMessage({
  id: 'fragments.addScreen.createAndGoShort',
  defaultMessage: 'Crear e ir',
});

/** Full label for the create-and-go option in the split-button menu. */
export const createAndOpenMessage = defineMessage({
  id: 'fragments.addScreen.createAndOpen',
  defaultMessage: 'Crear e ir al fragmento',
});
